import { render } from "./AdImageBox.vue?vue&type=template&id=1be0343d&scoped=true"
import script from "./AdImageBox.vue?vue&type=script&lang=js"
export * from "./AdImageBox.vue?vue&type=script&lang=js"

import "./AdImageBox.vue?vue&type=style&index=0&id=1be0343d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1be0343d"

export default script